import { useCallback, useState } from "react";
import Popup from "../../../components/Popup";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import ExpressKiosk from "../../../assets/img/SolutionsIcons/AgilysysExpressKiosk.svg";
import { Header } from "../../../components/Header";

const ExpressKioskFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash expressKioskFPage">
            <div className="page-title"><img src={ExpressKiosk} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                    Eliminate front desk queues and help make travel more
                    enjoyable by offering a fast and easy approach to efficient
                    guest service.{'\n\n'}
                </div>
                <div className="std-text">
                    Use Express Kiosk to give your guests the self-service
                    options they are looking for. Check-in, obtain card present
                    EMV authorization, offer upgrades and alternative room
                    options before dispensing the guest a key. Deploy the kiosk
                    in high traffic areas such as elevator banks or parking areas
                    and let guests quickly view their hotel folio, check-out and
                    receive an electronic copy instantly.{'\n\n'}
                </div>
                <div className="std-text">
                    Increase revenue, reduce overhead, and provide guests 
                    with the experience they are looking for with Express Kiosk.{'\n\n'}
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Express Kiosk", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/express1.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveExpressKiosk.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default ExpressKioskFPage;